import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { Box } from 'react-bulma-components'
import WorkerCounterTemplatesList from '../../components/worker-counters/list'
import WorkerCountersExplanation from '../../components/worker-counters/worker-counters-explanation'
import { useWorkerCounterTemplatesQuery } from '../../queries/worker-counter-templates'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { AddResourceIcon } from '../../components/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { isAuthorizedFor } from '../../components/protected/protected'

/**
 * Page pour gérer les compteurs de travailleurs dans les paramètres employeur
 * Affiche la liste des modèles de compteurs disponibles
 */
const WorkerCountersSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const { data: workerCounterTemplates } = useWorkerCounterTemplatesQuery(
    { employer: employer._id },
    { enabled: Boolean(employer._id) },
  )
  const navigate = useNavigate()
  const location = useLocation()

  const basePath = location.pathname.includes('/employers/')
    ? `/employers/${employer._id}`
    : '/settings'
  const isSuperAdmin = isAuthorizedFor(['superAdmin'])

  return (
    <>
      <SidebarContentTitle
        title="Compteurs"
        help={<WorkerCountersExplanation textColor={'white'} />}
        onButtonClick={isSuperAdmin ? () => navigate(`${basePath}/worker-counters/new`) : undefined}
        addButtonLabel="Nouveau compteur"
        buttonDataTestId="new-worker-counter"
        ButtonIcon={AddResourceIcon}
      />
      <Box>
        <WorkerCounterTemplatesList
          employerId={employer._id}
          workerCounterTemplates={workerCounterTemplates || []}
          noDataMessage="Aucun compteur de travailleur configuré"
        />
      </Box>
    </>
  )
}

export default WorkerCountersSettings
